import { INewbuildingPromoV2 } from '../../types/promosPage';
import { IApplicationState } from '../../types/redux';

export function selectNewbuildingPromosV2(state: IApplicationState): INewbuildingPromoV2[] {
  return state.promosPage.newbuildingPromosV2;
}
